export default "assets/avikam-logo.png"